export const getInitialValuesSecondStep = (firstStepForm) => ({
  nombre: "",
  apellido: "",
  dni: firstStepForm.values.dni,
  tipoMatricula: firstStepForm.values.tipoMatricula,
  nroMatricula: firstStepForm.values.nroMatricula,
  provincia: firstStepForm.values.provincia,
  telefono: "",
  especialidad: "", // Cambiado a un campo no obligatorio
  nacimiento: "", // Cambiado a un campo de tipo fecha y obligatorio
  sexo: "", // Cambiado a un campo obligatorio
  direccion: "", // Cambiado a un campo no obligatorio
  email: "",
  password: "",
  repassword: "",
  terminosCondiciones: false, // Nuevo campo de tipo booleano (checkbox)
});
